// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__rIIxA","active":"styles_active__tkKcQ","dark":"styles_dark__aBLg1"};